module.exports = __webpack_public_path__ + "public/img/4.6a1d4cc1.png";